module.exports = [{
      plugin: require('D:/Sources/linguistische-treffen/node_modules/gatsby-plugin-google-gtag/gatsby-browser.js'),
      options: {"plugins":[],"trackingIds":["G-3V8GRG0606"],"gtagConfig":{"anonymize_ip":true},"pluginConfig":{"respectDNT":true}},
    },{
      plugin: require('D:/Sources/linguistische-treffen/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
